import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableHead, TableRow } from '@mui/material';
import { TableCellWithWidth } from 'components/list/TableComponentsStyled';
import { Button } from '@totalsoft/rocket-ui';
import AddIcon from "@mui/icons-material/Add";

const FinancialProductDetailsInsurersTableHead = ({ canWrite, onAdd, isNewFinancialProduct }) => {
  const { t } = useTranslation();

  return (
    <TableHead>
      <TableRow>
        <TableCellWithWidth style={{ fontWeight: 'bold' }} w={10}>{t("FinancialProduct.Details.Insurers.InsuranceType")}</TableCellWithWidth>
        <TableCellWithWidth style={{ fontWeight: 'bold' }} w={10}>{t("FinancialProduct.Details.Insurers.Insurer")}</TableCellWithWidth>
        <TableCellWithWidth style={{ fontWeight: 'bold' }} w={10}>{t("FinancialProduct.Details.Insurers.InsuranceConvention")}</TableCellWithWidth>
        <TableCellWithWidth style={{ fontWeight: 'bold' }} w={10}>{t("FinancialProduct.Details.Insurers.Implicit")}</TableCellWithWidth>
        <TableCellWithWidth style={{ fontWeight: 'bold' }} w={10}>{t("FinancialProduct.Details.Insurers.Mandatory")}</TableCellWithWidth>
        <TableCellWithWidth w={10} align="right">
          <Button color="primary" variant="contained" startIcon={<AddIcon />} disabled={!isNewFinancialProduct || !canWrite} onClick={onAdd}>
            {t("Add")}
          </Button>
        </TableCellWithWidth>
      </TableRow>
    </TableHead>
  );
};

FinancialProductDetailsInsurersTableHead.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  isNewFinancialProduct: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired
};

export default FinancialProductDetailsInsurersTableHead;
